<div class="wrapper" [class.group]="!show">
  <div class="header" *ngIf="show">
    <h1 class="title">Portfolio</h1>
    <div class="selector">
      <div class="circle" [class.isActive]="currency === 'ARS'"></div>
      <div class="pill" [class.isActive]="currency === 'ARS'" (click)="changeCurrency('ARS')">
        <p [class.active]="currency === 'ARS'">AR$</p>
      </div>
      <div class="pill" [class.isActive]="currency === 'USD'" (click)="changeCurrency('USD')">
        <p [class.active]="currency === 'USD'">U$D</p>
      </div>
    </div>
    <p class="text-dca" [routerLink]="'/dca'" *ngIf="rulesActive">Tenés DCA activas</p>
  </div>
  <div class="titles">
    <ng-container *ngIf="show">
      <div class="coin-name-title">
        <span class="text">Nombre</span>
      </div>
      <div class="coin-price-title">
        <span class="text">Precio actual</span>
      </div>
      <div class="coin-chart-title">
        <span class="text">Gráfico 24 hs</span>
      </div>
      <div class="coin-variation-title">
        <span class="text">% 24 hs</span>
      </div>
      <div class="coin-balance-title">
        <span class="text">Total</span>
      </div>
    </ng-container>
    <div class="title-group" *ngIf="!show">
      <span class="text">Coins</span>
    </div>
  </div>
  <app-crypto-balance
    *ngFor="let balance of cryptoBalances"
    [balance]="balance"
    [equivalentInArs]="equivalentInArs"
    [show]="show"
    (click)="!show && clickCard(balance)"
  >
  </app-crypto-balance>
  <ng-container *ngIf="!hiddenBundle && this.authService.loggedUser?.balance?.bundle">
    <app-bundle-balance
      *ngFor="let bundleBalance of this.authService.loggedUser.balance.bundle['ARS'] | keyvalue"
      [ticker]="bundleBalance.key"
      [coinsAmounts]="bundleBalance.value"
      [currency]="currency"
    >
    </app-bundle-balance>
  </ng-container>

  <div
    class="no-portfolio-message"
    *ngIf="
      cryptoBalances.length === 0 &&
      object.keys(this.authService.loggedUser?.balance?.bundle?.ARS ?? {})?.length === 0
    "
  >
    <p>Aún no tenés criptomonedas en tu portfolio.</p>
  </div>
</div>
